// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivityLogs_container__1JvQX"};